//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BaseSidebar',
  props: {
    visible: { type: Boolean, required: true },
    maxWidth: { type: Number, default: 1000 }
  },
  watch: {
    visible () {
      if (this.visible) this.$store.commit('page/BLOCK_BODY_SCROLL')
      else this.$store.commit('page/ALLOW_BODY_SCROLL')
    }
  },
  created () {
    if (this.visible) this.$store.commit('page/BLOCK_BODY_SCROLL')
  },
  beforeDestroy () {
    this.$store.commit('page/ALLOW_BODY_SCROLL')
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
